module.exports = __webpack_public_path__ + "img/googlescanbarcode.6d848dc.png";